import moment from "moment";
import { capitalizeOne } from "./string";

import "moment/locale/pt-br";

export const translateDuration = str => {
	const minutes = moment.duration(str).minutes();
	const hours = (moment.duration(str).asMinutes() - minutes) / 60;
	return `${hours > 0 ? `${hours}h` : ""} ${minutes > 0 ? `${minutes}m` : ""}`;
};

export const timeToString = date => moment.utc(date).format("HH:mm");

export const dateToFullString = date => {
	const day = capitalizeOne(moment.utc(date).format("dddd"));
	const month = capitalizeOne(moment.utc(date).format("MMMM"));
	return `${day}, ${moment.utc(date).format("DD [de]")} ${month}`;
};

export const differenceInDays = (start, end) => {
	return moment
		.utc(end)
		.startOf("day")
		.diff(moment.utc(start).startOf("day"), "days");
};

export const dateToMediumString = date => {
	return capitalizeOne(moment.utc(date).format("ddd DD/MM/YY"));
};
